export const AppConfig = {
  name: process.env.REACT_APP_NAME,
  frontEndUrl: process.env.REACT_APP_FRONT_END_URL,
  backEndUrl: process.env.REACT_APP_BACK_END_URL
}
